module.exports = __webpack_public_path__ + "img/icon_3.d7a03804.png";